export default "__VITE_ASSET__DCaQ1YAT__"